import { Checkbox } from "@cmp-src/primitives/checkbox";
import React from "react";
import { useDataMan } from "../../hooks/useDataMan";
import { useDataManRow } from "../../hooks/useDataManRow";
import { DATA_MAN_CHECKBOX_CLASS } from "./dataManCheckboxClass";

export const DataManSelectControl: React.FC = () => {
  const { toggleSelectItem, isItemSelected, dataIdKey } = useDataMan();
  const { data } = useDataManRow();

  const idKey = dataIdKey || "id";
  const itemId = String(data?.[idKey] || "");
  const isSelected = isItemSelected(itemId);

  const handleCheckedChange = React.useCallback(() => {
    toggleSelectItem(itemId);
  }, [toggleSelectItem, itemId]);

  // Prevent the row-body action (e.g. opening a detail) from firing when the
  // checkbox itself is clicked.
  const handleClick = React.useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
  }, []);

  return (
    <Checkbox
      checked={isSelected}
      onCheckedChange={handleCheckedChange}
      onClick={handleClick}
      aria-label="Select row"
      className={DATA_MAN_CHECKBOX_CLASS}
    />
  );
};
